/**
 * The number staff should see for an order.
 *
 * Three kinds of order coexist:
 *   - Shopify orders     -> shopifyOrderNumber, e.g. "1042"
 *   - Admin-created      -> shopifyOrderNumber, e.g. "ADM-1787165615957"
 *   - Migrated (legacy)  -> no shopifyOrderNumber at all; migrate-legacy.ts writes
 *                           the portal's number to legacyOrderId instead
 *
 * Migrated orders used to fall through to `id.slice(0, 8)`, showing a fragment of a
 * UUID. That is the number the team was being asked to recognise for every order
 * placed before the migration, while their own paperwork said "40815492".
 *
 * The UUID fragment remains only as a last resort, for a record with neither number.
 *
 * `id` is optional because some API responses embed a trimmed rental (an agent's
 * commission rows, for instance) that carries the order number but no id. Those
 * callers get '' rather than a fabricated number, and decide their own placeholder.
 */
export function orderNumber(rental: {
  shopifyOrderNumber?: string | null;
  legacyOrderId?: number | null;
  id?: string;
}): string {
  if (rental.shopifyOrderNumber) return rental.shopifyOrderNumber;
  if (rental.legacyOrderId != null) return String(rental.legacyOrderId);
  return rental.id ? rental.id.slice(0, 8) : '';
}
